import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";
import { prepareEnumSearchParams } from "../utils/fetch/PrepareEnumSearchParams";

export const CashLevelService = {

    getList: (criteria) => {
        console.log('CashLevelService::getList-criteria', criteria);
        const params = prepareBaseGetListParams(criteria);
        return fetchWithAuth(`/portal/cash-levels?${params.toString()}`, { method: 'GET' });
    },
    getDetails: (deviceId, currency) => {
        return fetchWithAuth(`/portal/cash-levels/${deviceId}/${currency}`, { method: 'GET' });
    },
    getStatusList: () => {
        return fetchWithAuth(`/portal/cash-levels/status-list`, { method: 'GET' });
    },
    registerCashOperation: (request) => {
        return fetchWithAuth('/portal/cash-levels/operation', {
            method: 'POST',
            body: JSON.stringify(request)
        });
    },
    setBalance: (request) => {
        return fetchWithAuth('/portal/cash-levels/set-balance', {
            method: 'PUT',
            body: JSON.stringify(request)
        });
    },
    getOperationsHistory: (criteria, enums) => {
        const params = prepareBaseGetListParams(criteria);
        prepareEnumSearchParams(criteria.baseQuery, params, enums);
        return fetchWithAuth(`/portal/cash-levels/transactions?${params.toString()}`, { method: 'GET' });
    },
    
    getReconciliationStatusOptions: () => {
        return fetchWithAuth(`/portal/cash-levels/reconciliation-status-options`, { method: 'GET' });
    },
    getReconciliations: (criteria, onlyNotReconciled = false, enums = []) => {
        const params = prepareBaseGetListParams(criteria);
        prepareEnumSearchParams(criteria.baseQuery, params, enums);
        if (onlyNotReconciled) {
            params.append('only_not_reconciled', 'true');
        }
        return fetchWithAuth(`/portal/cash-levels/reconciliations?${params.toString()}`, { method: 'GET' });
    },
    findReconciliationByBagId: (bagId) => {
        return fetchWithAuth(`/portal/cash-levels/reconciliations/by-bag/${encodeURIComponent(bagId)}`, { method: 'GET' });
    },
    createReconciliation: (body) => {
        return fetchWithAuth('/portal/cash-levels/reconciliations', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },
    updateReconciliation: (operationId, body) => {
        return fetchWithAuth(`/portal/cash-levels/reconciliations/${encodeURIComponent(operationId)}`, {
            method: 'PUT',
            body: JSON.stringify(body)
        });
    },
    cancelReconciliation: (operationId) => {
        return fetchWithAuth(
            `/portal/cash-levels/reconciliations/${encodeURIComponent(operationId)}/cancel`,
            {
                method: 'PUT',
            }
        );
    },
}